export enum MapMarkerIcon {
  HwrcSite,
  DisposalSite,
  Active,
  Warning,
  Inactive,
  Offline
}
